import { isRouteErrorResponse, Link, useRouteError } from 'react-router-dom';

import { CircleX } from 'lucide-react';
import { Button } from '../ui/button';

export const RouterErrorFallback = () => {
  const error = useRouteError() as any;

  if (isRouteErrorResponse(error)) {
    return (
      <div className="flex h-screen w-screen flex-col items-center justify-center gap-4" role="alert">
        <CircleX className="text-red-500 size-16" />
        <h2 className="text-lg font-semibold">Ooops, något gick fel 😣</h2>
        <pre>
          {error.status} {error.statusText}
        </pre>
        {typeof error.data === 'string' ? <p>{error.data}</p> : null}
        <Button asChild>
          <Link to="/">Gå hem</Link>
        </Button>
      </div>
    );
  }

  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center gap-4" role="alert">
      <CircleX className="text-red-500 size-16" />
      <h2 className="text-lg font-semibold">Ooops, något gick fel 😣</h2>
      <pre>{error.message}</pre>
      <Button asChild>
        <Link to="/">Gå hem</Link>
      </Button>
    </div>
  );
};
